import { render, staticRenderFns } from "./CreateRole.vue?vue&type=template&id=5ac400ff&"
import script from "./CreateRole.vue?vue&type=script&lang=ts&"
export * from "./CreateRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports